<template>
  <div v-if="representative">
    <span class="title">{{ $t('titles.tournament_representative') }}</span>
    <div class="representative" @click="openProfileFn">
      <div class="item" v-for="field in fields" :key="field.key">
        <div class="label">{{ $t(field.labelKey) }}</div>
        <div class="value">{{ representative[field.key] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RepresentativeInfo',
  props: {
    representative: { type: Object, required: true }
  },
  computed: {
    fields () {
      return [
        { key: 'name', labelKey: 'params.name' },
        { key: 'surname', labelKey: 'params.surname' },
        { key: 'phone', labelKey: 'params.phone' },
        { key: 'email', labelKey: 'params.email' }
      ]
    }
  },
  methods: {
    openProfileFn () {
      this.$emit('openProfile', this.representative.id)
    }
  }
}
</script>

<style lang="scss" scoped>
  .representative {
    margin-top: 20px;
    background-color: #f5f5f5;
    border-radius: 3px;
    text-align: center;
    overflow: hidden;
    margin-bottom: 24px;
    padding: 6px 12px;
    height: auto;
    transition: background-color 0.5s ease;
    cursor: pointer;

    .item {
      display: inline-block;
      margin-bottom: 6px;
      width: 50%;

      &.mid {
        width: 50%;
      }

      .alergy {
        color: inherit;
        font-size: inherit;
        font-weight: inherit;

        &:after {
          content: ", ";
        }
        &:last-of-type:after {
          content: "";
        }
      }
    }

    .label,
    .value {
      display: inline-block;
      font-size: 15px;
    }
    .label {
      width: 100px;
      text-align: right;
      margin-right: 12px;
      text-transform: uppercase;
      font-size: 12px;

      &:after {
        content: ":";
      }
    }
    .value {
      font-weight: bold;
    }

    &:hover {
      background-color: #e9e9e9;
    }
  }
</style>
